module.exports = __webpack_public_path__ + "images/ms.png?576d79932aa82d27372c353e994ba526";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ms.png
// module id = 51
// module chunks = 0